import { Component, Label, Node, _decorator } from 'cc';
import Lobby from '../../../../System/Lobby';
import NumberFormatter from '../../../../../common/scripts/Toolkit/Components/Label/NumberFormatter';
import { JACKPOT_QUERY_TYPE } from '../../../Data/Model/LobbyHistoryModel';

const { ccclass, property } = _decorator;

@ccclass('HistoryRecordTitle')
export default class HistoryRecordTitle extends Component {
    @property(Label)
    private readonly machineInfoLabel: Label = null;

    @property(NumberFormatter)
    private readonly profitOrLossNumber: NumberFormatter = null;

    @property(Node)
    private readonly recordOfToday: Node = null;

    public display(getProfitOrLoss: Promise<number>, machineName: string, machineID: number) {
        const isJackpot = machineID === JACKPOT_QUERY_TYPE;
        if (!isJackpot) {
            this.machineInfoLabel.string = `${machineName} (${machineID})`;
            // only show record of today when in game
            this.recordOfToday.active = !!Lobby.currentTable;
        }
        getProfitOrLoss.then((profitOrLoss) => {
            this.profitOrLossNumber.value = profitOrLoss;
        });
    }
}
